import Image from "next/image";
import { ImageProps } from "next/image";
import ExternalImage from "./ExternalImage";
import { getUrlForLocalImage, getUrlForStaticImage } from "../../utils/common";

export const BaseImage = ({ src, ...rest }: ImageProps) => {
  const isExternal = (src as string)?.startsWith?.("http");
  const isStaticImage = typeof src === "object";
  const computedSrc = isExternal
    ? (src as string)
    : isStaticImage
    ? getUrlForStaticImage(src)
    : getUrlForLocalImage(src);

  if (isExternal) {
    return (
      <ExternalImage
        src={computedSrc}
        alt={rest.alt}
        h={`${rest.height}px`}
        w={`${rest.width}px`}
      />
    );
  }

  return <Image src={computedSrc} alt={rest.alt || "image"} {...rest} />;
};

export default BaseImage;
